<div class="modal-backdrop">
  <div class="modal">
    <div class="modal__header">
      <h3 class="modal__title">{{ title }}</h3>
      <button class="modal__close" type="button"><pdq-icon icon="close"></pdq-icon></button>
    </div>

    <div class="modal__progress">
      <s-polaris-progress-bar [progress]="progress()"></s-polaris-progress-bar>
    </div>

    <div class="modal__body">
      <h4 class="modal__step-title">{{ currentStep()?.title }}</h4>
      @if (currentStep()?.description) {
        <p class="modal__step-description" [innerHTML]="currentStep()?.description | safe: 'html'"></p>
      }

      @switch (currentStep()?.key) {
        @case ('items') {
          <div class="modal-items">
            @for (item of items; track item.name) {
              <div class="modal-item" [class.modal-item--disabled]="!item.available">
                <s-polaris-product-thumbnail
                  [image]="item.thumbnail"
                  [quantity]="item.cartQuantity"
                  [size]="56"></s-polaris-product-thumbnail>
                <div class="modal-item__details">
                  <span class="modal-item__name">{{ item.name }}</span>
                  <s-polaris-text color="subdued">{{ item.subtitle }}</s-polaris-text>
                </div>
                @if (item.available) {
                  <s-polaris-text-field type="number" value="0"></s-polaris-text-field>
                } @else {
                  <s-polaris-button variant="secondary">Unavailable</s-polaris-button>
                }
              </div>
            }
          </div>
        }
        @case ('address') {
          <div class="address-form">
            <s-polaris-select label="Country" value="United States"></s-polaris-select>
            <div class="field-row">
              <s-polaris-text-field label="First name"></s-polaris-text-field>
              <s-polaris-text-field label="Last name"></s-polaris-text-field>
            </div>
            <s-polaris-text-field label="Address"></s-polaris-text-field>
            <s-polaris-text-field label="Apartment, suite, etc."></s-polaris-text-field>
            <div class="field-row field-row--triple">
              <s-polaris-text-field label="City"></s-polaris-text-field>
              <s-polaris-select label="State"></s-polaris-select>
              <s-polaris-text-field label="ZIP"></s-polaris-text-field>
            </div>
            <s-polaris-text-field label="Phone number"></s-polaris-text-field>
          </div>
        }
        @case ('shipping') {
          <s-polaris-choice-list variant="block" [choices]="shippingChoices"></s-polaris-choice-list>
        }
        @case ('giftNote') {
          <div class="gift-note">
            <div class="field-row">
              <s-polaris-text-field label="To"></s-polaris-text-field>
              <s-polaris-text-field label="From"></s-polaris-text-field>
            </div>
            <s-polaris-text-field label="Message" [multiline]="true"></s-polaris-text-field>
            <s-polaris-text color="subdued">0 / {{ messageLimit }}</s-polaris-text>
          </div>
        }
      }
    </div>

    <div class="modal__footer">
      <div class="modal__footer-actions">
        @if (!isFirstStep()) {
          <s-polaris-button variant="secondary" (pressed)="back()">Back</s-polaris-button>
        }
        @if (isLastStep()) {
          <s-polaris-button variant="primary" (pressed)="reset()">Save</s-polaris-button>
        } @else {
          <s-polaris-button variant="primary" (pressed)="next()">Next</s-polaris-button>
        }
      </div>
    </div>
  </div>
</div>
